import Balance from "@mui/icons-material/Balance";
import LinkIcon from "@mui/icons-material/Link";
import MenuBook from "@mui/icons-material/MenuBook";
import { Chip } from "@mui/material";
import { type ReactElement } from "react";

import { CITATION_NO_URL_HREF, type CitationIconKind } from "./scoutCitations";

function renderCitationChipIcon(kind: CitationIconKind): ReactElement {
  if (kind === "regulation") {
    return <Balance />;
  }
  if (kind === "link") {
    return <LinkIcon />;
  }
  return <MenuBook />;
}

/** How a Scout citation looks wherever Scout's writing is shown. */
export function CitationChip({
  href,
  label,
  iconKind,
}: {
  href: string | undefined;
  label: string;
  iconKind: CitationIconKind;
}) {
  const isClickable = Boolean(href && href !== CITATION_NO_URL_HREF);
  const commonSx = {
    height: 22,
    mx: 0.25,
    verticalAlign: "baseline",
    bgcolor: "grey.300",
    color: "text.primary",
    fontSize: "0.8125rem",
    "& .MuiChip-icon": {
      fontSize: "1rem",
      ml: 0.5,
      mr: -0.25,
      color: "text.secondary",
    },
    "& .MuiChip-label": {
      px: 0.75,
    },
  } as const;

  if (isClickable && href) {
    return (
      <Chip
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        clickable
        size="small"
        label={label}
        icon={renderCitationChipIcon(iconKind)}
        sx={commonSx}
      />
    );
  }

  return (
    <Chip
      component="span"
      size="small"
      label={label}
      icon={renderCitationChipIcon(iconKind)}
      sx={commonSx}
    />
  );
}
